import HttpClient from 'es/core/net/http';
import Guid from 'es/core/types/Guid';
import passThroughResponseInterceptor from './passThroughResponseInterceptor';
import IAccessControlSet from 'es/app/security/IAccessControlSet';

import LogManager from 'es/core/logging/LogManager';
const logger = LogManager.getLogger('app.business-logic.services.security.fetchAccessControls');

export async function fetchAccessControls(
    companyId?: Guid | null,
    facilityId?: Guid | null
): Promise<IAccessControlSet> {
    const fetchOptions = {
        responseInterceptor: passThroughResponseInterceptor,
    };

    try {
        const response = await HttpClient.useInternalApi
            .withCredentials()
            .get('security/access-controls', { companyId, facilityId }, fetchOptions);

        if (response.isSuccess) return response.data;

        if (response.status !== 401) {
            logger.error('[FetchAccessControls] error: ', response.error);
        }
    } catch (error) {
        logger.error('[FetchAccessControls] error: ', error);
    }

    // Return an empty access control set if there is no matching access controls for the requested auth domain.
    return {};
}

export default fetchAccessControls;
